<template>
  <div class="mb-1 row event align-items-end">
    <div class="col-8 d-flex flex-wrap justify-content-start">
      <div class="ml-1">
        <div class="d-flex">
          <ActivityIcon :type="item.type" class="activity-icon"></ActivityIcon>
          <div class="d-flex flex-column ml-1">
            <p class="typo-paragraph14 typo-medium mb-1 dark-text">{{ title }}</p>
            <span v-if="isUnknownUser" class="typo-paragraph12 d-block typo-medium">{{ item.user.name }}</span>
            <div v-else class="d-flex align-items-center">
              <span class="typo-paragraph12 d-block typo-medium user-role" :class="item.user.role">{{ $t(`storeSettings.eventLogs.event.role.${item.user.role}`) }}</span>
              <span class="ml-px-4 typo-paragraph12 d-block typo-medium">{{ item.user.name }}</span>
              <span class="ml-px-4 typo-paragraph12 d-block typo-medium">-</span>
              <span
                class="ml-px-4 typo-paragraph12 d-block typo-medium copy-clipboard" 
                @mouseover="emailTooltip = true" 
                @mouseleave="emailTooltip = false"
                @click="copyEmail" 
              >
                <div v-if="emailTooltip" class="tool-tip email-tool-tip typo-regular">
                  {{copyEmailMsg}}
                </div>
                {{ item.user.email }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2 d-flex">
      <span class="typo-paragraph12 typo-medium d-block mr-1">
        {{$t("storeSettings.eventLogs.event.ip")}}:
      </span>
      <span 
        class="typo-paragraph12 typo-medium d-block copy-clipboard" 
        @mouseover="ipTooltip = true" 
        @mouseleave="ipTooltip = false"
        @click="copyIp" 
      >
        <div v-if="ipTooltip" class="tool-tip ip-tool-tip typo-regular">
          {{copyIpMsg}}
        </div>
        {{item.user.ip }}
      </span>
    </div>
    <div v-if="timeItem.date && timeItem.utcTime" class="col-2 d-flex flex-column align-items-end">
      <span class="mb-1 typo-paragraph14 typo-medium dark-text">{{timeItem.date}}</span>
      <span class="typo-paragraph12 typo-medium event__user--color">{{timeItem.utcTime}}</span>
    </div>
    <div v-else class="col-2 d-flex flex-column align-items-end">
      <span class="mb-1 typo-paragraph14 typo-medium dark-text">{{timeItem.date}}</span>
      <span class="typo-paragraph12 typo-medium event__user--color">{{timeItem.timeAgo}}</span>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import ActivityIcon from "./ActivityIcon";
import TimeMaker from "@/plugins/timemaker";

export default {
  components: {ActivityIcon},
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    showDetail: false,
    copiedIp: false,
    copiedEmail: false,
    emailTooltip: false,
    ipTooltip: false,
  }),
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    copyIpMsg() {
      return this.copiedIp ? this.$t(`storeSettings.eventLogs.event.copied`) : this.$t(`storeSettings.eventLogs.event.click_to_copy`);
    },
    copyEmailMsg() {
      return this.copiedEmail ? this.$t(`storeSettings.eventLogs.event.copied`) : this.$t(`storeSettings.eventLogs.event.click_to_copy`);
    },
    canclick() {
      return !["login", "logout", "share_library", "app_charged", "delete_page",].includes(this.item.type);
    },
    title() {
      if (["login", "logout", "share_library", "app_charged",].includes(this.item.type)) {
        return this.$t(`storeSettings.eventLogs.event.title.${this.item.type}`);
      }
      const page_title = this.item.data.g_title;
      return this.$t(`storeSettings.eventLogs.event.title.${this.item.type}`) + ": " +  page_title;
    },
    isUnknownUser() {
      return this.item.user.name == this.$t("storeSettings.eventLogs.unknowUser");
    },
    timeItem() {
      //kiểm tra nếu hơn 1 ngày thì show time UTC
      const timeMaker = new TimeMaker(this.item.date);
      const diff = Math.round((new Date() - timeMaker) / 1000);
      const dateValue = timeMaker.format("dd/MM/yyyy");
      if(diff > 86400){
        //86400 là 1 ngày
        const utcTimeValue = timeMaker.format("HH:mm") + " " + this.$t("storeSettings.eventLogs.event.utc");
        return {date: dateValue, utcTime: utcTimeValue};
      }
      const timeAgoValue = timeMaker.ago(this.language); 
      return {date: dateValue, timeAgo: timeAgoValue}
    },
  },
  methods: {
    closePopup() {
      if (this.showDetail) {
        this.showDetail = false;
      }
    },
    copyIp() {
      navigator.clipboard.writeText(this.item.user.ip).then(() => {
        this.copiedIp = true;
        setTimeout(() => {
          this.copiedIp = false;
        }, 500);
      }, (err) => {
        // eslint-disable-next-line no-console
        console.error('Async: Could not copy text: ', err);
      });
    },
    copyEmail() {
      navigator.clipboard.writeText(this.item.user.email).then(() => {
        this.copiedEmail = true;
        setTimeout(() => {
          this.copiedEmail = false;
        }, 500);
      }, (err) => {
        // eslint-disable-next-line no-console
        console.error('Async: Could not copy text: ', err);
      });
    },
    gotoDetail(){
      if (this.canclick){
        window.location.href = `/editor?id=${this.item.data.g_id}&type=${this.item.data.g_type}&handle=${this.item.data.g_handle}`
      }
    },
    showDetailEvent(){
      this.showDetail = !this.showDetail;
    }
  }
}
</script>

<style lang="scss" scoped>
.w31 {
  width: 31px;
}

.d-block {
  color: $textLightModeLow;
}

.activity-icon {
  margin-top: 2px;
}

.event {
  background-color: $light1;
  padding: 14px 4px 16px 0px;
  min-height: 56px;
  border-radius: 3px;

  &:hover {
    -webkit-box-shadow: 0px 12px 38px rgba(34, 34, 34, 0.0393604), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545), 0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455), 0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14);
    box-shadow: 0px 12px 38px rgba(34, 34, 34, 0.0393604), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545), 0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455), 0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14);

    .event {
      &__user {
        &--detail {
          background-color: $light3;
          &:hover {
            path {
              fill: #3C67FF;
            }
          }
        }
      }
    }
  }

  &__user {
    display: flex;
    align-items: flex-start;

    &--color {
      color: #666666;
    }

    &--active {
      background-color: $light3;
    }

    &--detail {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 2px;
      margin-left: 4px;

      &:hover {
        background-color: $light3;
      }
    }
  }

  &__icon {
    path {
      fill: #666666;
    }

    &--active {
      path {
        fill: #3C67FF;
      }
    }
  }

  &__popup {
    z-index: 1;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: $light1;
    filter: drop-shadow(0px 12px 26px rgba(0, 0, 0, 0.06)) drop-shadow(0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313)) drop-shadow(0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664)) drop-shadow(0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03)) drop-shadow(0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336)) drop-shadow(0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687));

    & > div {
      padding: 9px 16px;

      &:hover{
        background-color: $light2;
      }
    }

    &--copy {
      margin-left: 8px;
      position: relative;

      path {
        fill: #212121;
      }

      &:hover {
        path {
          fill: $mono3;
        }
      }

      &--disabled {
        path {
          fill: $textLightModeDisabled;
        }
      }
    }
  }

  &__notice {
    position: absolute;
    top: 0;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translate(-50%, -100%);

    &--content {
      padding: 4px 8px;
      border-radius: 3px;
      background-color: $dark1;
      color: $textDarkModeHigh;
    }

    &--arrow {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      border-top: 4px solid $dark1;
    }
  }
}

.user-role { 
  border-radius: 3px;
  color: map-get($light-text, "600");
  padding: 1px 4px;
}
.owner {
  background-color: $cYellow3;
}
.staff {
  background-color: $mono1;
}
.collaborator {
  background-color: $cTeal2;
}

.ml-px-4 {
  margin-left: 4px;
}

.dark-text {
  color: $textLightModeHigh;
}

.copy-clipboard {
  position: relative;
  cursor: pointer;
  &:hover{
    color: $mono5;
  }
}

.tool-tip{
  padding: 5px;
  border-radius: 3px;
  color: $textDarkModeHigh;
  background-color: $dark1;
  position: absolute;
  bottom: 150%;
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  left: 50%;
  transform: translateX(-50%);
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: $dark1 transparent transparent transparent;
  }
}
</style>
